export default {"src":"/_next/static/media/close.594b5ee2.svg","height":24,"width":24};